var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdgecapital = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 29,
    viewBox: "0 0 144 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_88_44",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 144,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 0H0V29H144V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_88_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.931 3.66014C76.7373 3.13559 76.4182 2.66292 75.9795 2.22484C75.2046 1.44666 74.1391 1.05469 72.783 1.05469H61.4616C61.4616 2.50729 62.6296 3.68896 64.0654 3.68896H65.5697H71.9512C71.9854 3.68896 72.0252 3.68896 72.0594 3.68896C72.5893 3.70625 73.0337 3.83883 73.3756 4.1501C73.7403 4.45561 73.9283 4.89369 73.9283 5.44129V8.44447C73.9283 8.98055 73.7403 9.40711 73.3642 9.7299C73.0053 10.047 72.538 10.2084 71.9512 10.2199H64.6751V8.60011V8.35225V5.71798H61.4502V8.60011V12.8945H72.7717C74.1049 12.8945 75.1704 12.5026 75.9681 11.7013C76.7544 10.9174 77.1475 10.0066 77.1475 8.98632V4.96863C77.1475 4.50172 77.0735 4.0694 76.9196 3.66014H76.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.472 10.214C91.4378 10.214 91.4093 10.214 91.3751 10.2198H85.2101C84.6403 10.2083 84.1731 10.0526 83.8027 9.72981C83.4381 9.40701 83.2501 8.98046 83.2501 8.44438V6.74969V5.54496C83.2501 5.54496 83.2785 3.70039 85.2671 3.6831H91.717C93.3636 3.6831 94.8336 2.62824 95.3749 1.04883H84.7543C80.8057 1.04883 80.0137 3.71769 80.0137 5.52766V8.94011C80.0137 9.97767 80.4012 10.8885 81.1932 11.6897C82.0079 12.4852 83.062 12.8771 84.3782 12.8771H92.1329C93.187 12.8598 94.0872 12.5198 94.8222 11.8569C95.3578 11.3784 95.6997 10.8251 95.8422 10.1968H91.4606L91.472 10.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7197 5.86816H92.7138H93.5742C94.8846 5.86816 95.9444 6.94031 95.9444 8.26033H91.9845C90.4974 8.26033 89.1812 7.2977 88.7197 5.86816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.443 8.13309H107.01C108.514 8.13309 109.847 7.16469 110.326 5.72363H98.2236V12.8887H110.497L111.374 10.2544H101.438V8.13309H101.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.799 3.68896L111.677 1.05469H98.2295C98.2295 2.50729 99.3919 3.68896 100.828 3.68896H110.793H110.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2857 8.13309H54.8524C56.3566 8.13309 57.6899 7.16469 58.1685 5.72363H46.0664V12.8887H58.3394L59.2169 10.2544H49.28V8.13309H49.2857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6357 3.68896L59.5132 1.05469H46.0664C46.0664 2.50729 47.2288 3.68896 48.6646 3.68896H58.63H58.6357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9869 17.166V29H95.7676V17.166H98.9869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.999 26.3254L143.093 29H131.19V17.166H134.421V26.3312H144.005L143.999 26.3254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8556 25.8411C49.4909 25.5183 49.3029 25.0918 49.3029 24.5557V23.449V22.861V21.6563C49.3029 21.6563 49.3314 19.8175 51.3085 19.8002H56.5391C58.1857 19.8002 59.6501 18.7396 60.1857 17.1602H53.1774C53.0976 17.1602 53.0293 17.1717 52.9609 17.1774V17.1602H50.8128C46.8643 17.1602 46.0723 19.829 46.0723 21.639V21.8234V23.253V23.8179V25.0514C46.0723 26.089 46.4654 26.9998 47.2574 27.7952C48.0722 28.5965 49.1263 28.9884 50.4482 28.9884H55.6616C57.3197 28.9884 58.7954 27.9105 59.3139 26.3138H51.2743C50.7046 26.3023 50.2373 26.1409 49.8613 25.8238L49.8556 25.8411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7115 29H77.4436L70.384 17.166H66.8116L59.752 29H63.4384L64.6862 26.8673H66.5323C67.9681 26.8673 69.1306 25.6856 69.1306 24.233H66.2247L68.5551 20.2384L73.7173 29H73.7115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.058 29H129.79L122.73 17.166H119.158L112.098 29H115.785L117.032 26.8673H118.878C120.314 26.8673 121.477 25.6856 121.477 24.233H118.571L120.901 20.2384L126.063 29H126.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.346 17.1602H103.757C102.315 17.1602 101.147 18.3361 101.141 19.7944H106.4V28.9942H109.625V19.7944H112.736C114.178 19.7944 115.346 18.6185 115.352 17.1602H115.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0328 17.166H78.8338C78.8338 18.6186 79.9961 19.8003 81.432 19.8003H82.0758H88.7764C89.1753 19.8003 89.9786 19.8291 89.9786 20.8263C89.9786 21.8235 89.2151 21.8235 88.7251 21.8235H82.0815H78.8281V29.0058H82.053V24.452H89.0328C90.5826 24.452 93.2492 24.4175 93.2492 20.7283C93.2492 17.6444 90.6795 17.1718 89.0328 17.1718V17.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1293 29.0001H28.2152C27.6625 29.0001 27.1497 28.7061 26.8706 28.2219L24.694 24.4694L15.6687 8.91741L6.64339 24.4636H13.8454C17.0647 24.4636 20.0446 26.1871 21.6742 28.9943H4.01672H1.56097C0.358738 28.9943 -0.393369 27.6686 0.216294 26.6195L14.324 2.31733C14.928 1.27976 16.4094 1.27976 17.0134 2.31733L18.2555 4.46163L29.8676 24.4694H35.0412L26.0159 8.92317C24.4205 6.16785 24.4205 2.75541 26.0159 0.00585938L41.4683 26.631C42.0779 27.6801 41.3315 29.0059 40.1236 29.0059L40.1293 29.0001Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 29,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdgecapital);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edgecapital.d62be533c742b22f8ea23f2f9236b283.svg";